import { Injectable } from '@angular/core';
import { IFilterListService } from './ifilter-list.service';
import { map } from 'rxjs';
import { Selectable } from '../models/types/selectable.type';
import { GetQuery } from '../../models/shared/enums/get-query.enum';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { WrapperResultGraphQL } from '../../models/shared/types/wrapper-result-graphql.type';
import { PageInfo } from '../../models/shared/types/page-info.type';
import { Color } from '../../models/common/color.model';
import { SizeGroup } from '../../models/common/size-group.model';

@Injectable({
  providedIn: 'root'
})
export class SizeGroupFilterService extends IFilterListService<SizeGroup> {
  pageInfo: PageInfo = { hasPreviusPage: false, hasNextPage: false, startCursor: null, endCursor: null };

  search(searchText: string, variables: any, isFirst: boolean): void {
    if (searchText || isFirst) this.pageInfo = { ...this.pageInfo, endCursor: null, startCursor: null };
    const filters = { search: searchText, companyId: this.appService.companyId, first: variables.first, after: searchText ? null : this.pageInfo.endCursor };
    this.graphQlService.getData<SizeGroup>(GetQuery.GET_SIZE_GROUPS_NO_IDS, filters)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        map((res: any) => res['data']['sizeGroups'])
      )
      .subscribe({
        next: (res: WrapperResultGraphQL<SizeGroup>) => {
          let datasource: Array<Selectable<SizeGroup>> = [];
            datasource = res.nodes.map(el => ({ ...el, displayId: el.id!, displayName: el.name, disabled: false, selected: false }));
          this.datasource.next(datasource);
        }
      })
  }
}
